import { ProductSets } from "modules/productSets";

const ProductSetsPage = () => {
  return <ProductSets />;
};

export default ProductSetsPage;
